"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Inbox/InboxList/Item/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactredux = require('react-redux');



var _inbox = require('shared/hooks/inbox');
var _time = require('shared/services/time');
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);






var _blobject = require('shared/selectors/blobject');
var _conversation = require('shared/selectors/conversation');
var _session = require('shared/selectors/session');
var _scheduledMessages = require('shared/selectors/scheduledMessages');
var _requests = require('shared/selectors/requests');
var _scheduledMessages3 = require('shared/services/scheduledMessages');
var _chat = require('shared/enum/chat');
var _hooks = require('web/services/hooks');
var _user = require('shared/selectors/user');
var _pins = require('shared/services/pins');

var _InboxItemAvatar = require('../../InboxItemAvatar'); var _InboxItemAvatar2 = _interopRequireDefault(_InboxItemAvatar);
var _ActionBtn = require('./ActionBtn'); var _ActionBtn2 = _interopRequireDefault(_ActionBtn);
var _RowMenu = require('./RowMenu'); var _RowMenu2 = _interopRequireDefault(_RowMenu);
var _Spinner = require('web/components/Spinner');
var _FirstTimeTooltips = require('web/components/FirstTimeTooltips');
var _InsecureTextTag = require('web/components/SecureText/InsecureTextTag');
var _KeywordChip = require('web/components/Requests/KeywordChip'); var _KeywordChip2 = _interopRequireDefault(_KeywordChip);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _icons = require('../icons');

const AVATAR_SIZE = 40













const stopPropagation = e => e.stopPropagation()

// "Front Desk", "Front Desk and Billing", "Front Desk, Billing and Nights".
const listNames = (names) =>
  names.length < 2 ? names.join('') : `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`

const InboxListItem = ({
  hasTooltip,
  isSelected = false,
  blobjectKey,
  activeFilter,
  isBeingArchived = false,
  onToggleArchived,
  onMarkUnread,
  onTogglePinned,
}) => {
  const selectMetadata = _react.useMemo.call(void 0, _blobject.makeSelectBlobjectMetadata, [])
  const selectMyTeams = _react.useMemo.call(void 0, _blobject.makeSelectMyPopulatedBlobjectTeams, [])

  const {
    name,
    description,
    isUnread,
    unreadMentions,
    isMuted,
    isCompleted: isCompletedByUser,
    lastUpdated,
    wrappedKey,
    wrappedType,
  } = _hooks.useAppSelector.call(void 0, 
    state => selectMetadata(state, blobjectKey),
    _reactredux.shallowEqual,
  )
  const draftMessage = _hooks.useAppSelector.call(void 0, 
    state => _conversation.selectDraftByConversationKey.call(void 0, state, wrappedKey),
  )
  const hasUnsentScheduled = _hooks.useAppSelector.call(void 0, state => _scheduledMessages.selectHasUnsentScheduled.call(void 0, state, blobjectKey))
  const requestKeywords = _hooks.useAppSelector.call(void 0, state => _requests.selectOpenRequestKeywordsByBKey.call(void 0, state, blobjectKey))
  const myTeams = _hooks.useAppSelector.call(void 0, 
    state => selectMyTeams(state, blobjectKey),
    _reactredux.shallowEqual,
  )
  const selectedTeamKey = _hooks.useAppSelector.call(void 0, _session.selectSelectedTeamKey)
  const teamSubscribers = _hooks.useAppSelector.call(void 0, state => _optionalChain([_blobject.selectBlobjectByKey.call(void 0, state, blobjectKey), 'optionalAccess', _ => _.TeamSubscribers]))
  const myInboxableTeamKeys = _hooks.useAppSelector.call(void 0, _blobject.selectMyInboxableTeamKeys)
  const myUserKey = _hooks.useAppSelector.call(void 0, _user.selectCurrentUserKey)
  const pinnedAt = _hooks.useAppSelector.call(void 0, state => {
    const b = _blobject.selectBlobjectByKey.call(void 0, state, blobjectKey)
    return b ? _pins.myPinnedAt.call(void 0, b, myUserKey) : null
  })
  const isPinned = !!pinnedAt

  // Inside a team's inbox every row belongs to that team, so its name would
  // only repeat; the other teams the chat is shared with still show.
  const teamNames = _react.useMemo.call(void 0, 
    () => myTeams
      .filter(t => t.TeamKey !== selectedTeamKey)
      .map(t => t.Name)
      .join(' · '),
    [myTeams, selectedTeamKey],
  )

  const isCompleted = activeFilter === _inbox.BlobjectFilter.COMPLETED

  const onInboxItemClick = _react.useCallback.call(void 0, 
    () => wrappedType && wrappedKey &&
      _actions2.default.gotoBlobject(wrappedType, wrappedKey, blobjectKey),
    [wrappedKey, wrappedType, blobjectKey],
  )


  const isInsecure = wrappedType === _chat.CHAT_TYPE.REGULAR_PATIENT
  const hasMetaLine = hasUnsentScheduled || isInsecure || requestKeywords.length > 0 || !!teamNames

  // A row is in Archived when you archived it, or when a team of yours did.
  // Your own archive gets "Unarchive" (UnCompleteBlobject). A team's archive
  // gets "Unarchive for {team}", which unarchives it for that team, for
  // everyone (SetBlobjectCompletedForTeams, as "Archive for…" does). Only teams
  // you're on qualify, as the server requires; with none, the row keeps its time.
  const archivedForTeams = _react.useMemo.call(void 0, 
    () => (isCompleted && !isCompletedByUser
      ? myTeams.filter(t => _optionalChain([teamSubscribers, 'optionalAccess', _2 => _2[t.TeamKey], 'optionalAccess', _3 => _3.Completed]) && (selectedTeamKey
        ? t.TeamKey === selectedTeamKey
        : myInboxableTeamKeys.includes(t.TeamKey)))
      : []),
    [isCompleted, isCompletedByUser, myTeams, teamSubscribers, selectedTeamKey, myInboxableTeamKeys],
  )
  const teamKeysToUnarchive = _react.useMemo.call(void 0, () => archivedForTeams.map(t => t.TeamKey), [archivedForTeams])
  const actionLabel = archivedForTeams.length
    ? `Unarchive for ${listNames(archivedForTeams.map(t => t.Name))}`
    : undefined

  const handleToggleArchived = _react.useCallback.call(void 0, 
    () => (teamKeysToUnarchive.length
      ? _optionalChain([onToggleArchived, 'optionalCall', _4 => _4(blobjectKey, teamKeysToUnarchive)])
      : _optionalChain([onToggleArchived, 'optionalCall', _5 => _5(blobjectKey)])),
    [onToggleArchived, blobjectKey, teamKeysToUnarchive],
  )

  const canToggleArchived = !!onToggleArchived
    && (isCompleted ? isCompletedByUser || archivedForTeams.length > 0 : true)
  const shouldShowActionBtn = canToggleArchived || (!!onToggleArchived && isBeingArchived)

  // The row menu (D-6): Pin or Unpin, "Mark as unread" on a read chat, then
  // the row's Archive or Unarchive. Right-click, Shift+F10, the Context Menu
  // key and the … button open it.
  const menuItems = _react.useMemo.call(void 0, () => {
    const items = []
    if (onTogglePinned) {
      items.push(isPinned
        ? { key: 'pin', label: 'Unpin', icon: _react2.default.createElement(_icons.UnpinIcon, { size: 20, __self: this, __source: {fileName: _jsxFileName, lineNumber: 160}} ), onSelect: () => onTogglePinned(blobjectKey, false, pinnedAt) }
        : { key: 'pin', label: 'Pin', icon: _react2.default.createElement(_icons.PinIcon, { size: 20, __self: this, __source: {fileName: _jsxFileName, lineNumber: 161}} ), onSelect: () => onTogglePinned(blobjectKey, true, null) })
    }
    if (!isUnread && onMarkUnread) {
      items.push({ key: 'mark-unread', label: 'Mark as unread', icon: _react2.default.createElement(_icons.MarkUnreadIcon, { size: 20, __self: this, __source: {fileName: _jsxFileName, lineNumber: 164}} ), onSelect: () => onMarkUnread(blobjectKey) })
    }
    if (canToggleArchived) {
      items.push({
        key: 'archive',
        label: _nullishCoalesce(actionLabel, () => ( (isCompleted ? 'Unarchive' : 'Archive'))),
        icon: isCompleted ? _react2.default.createElement(_icons.UnarchiveIcon, { size: 20, __self: this, __source: {fileName: _jsxFileName, lineNumber: 170}} ) : _react2.default.createElement(_icons.ArchiveIcon, { size: 20, __self: this, __source: {fileName: _jsxFileName, lineNumber: 170}} ),
        onSelect: handleToggleArchived,
      })
    }
    return items
  }, [onTogglePinned, isPinned, pinnedAt, isUnread, onMarkUnread, blobjectKey, canToggleArchived, actionLabel, isCompleted, handleToggleArchived])
  const hasMenu = menuItems.length > 0 && !isBeingArchived

  const [isMenuOpen, setIsMenuOpen] = _react.useState.call(void 0, false)
  const moreBtnRef = _react.useRef(null)
  // Where focus goes back to when the menu closes: what had it when the menu
  // opened from the keyboard, else the … button.
  const openerRef = _react.useRef(null)
  const openMenu = _react.useCallback.call(void 0, (opener) => {
    openerRef.current = opener
    setIsMenuOpen(true)
  }, [])
  const closeMenu = _react.useCallback.call(void 0, (returnFocus) => {
    setIsMenuOpen(false)
    if (returnFocus) _optionalChain([(_nullishCoalesce(openerRef.current, () => ( moreBtnRef.current))), 'optionalAccess', _6 => _6.focus, 'call', _7 => _7()])
  }, [])
  const onMoreClick = _react.useCallback.call(void 0, (e) => {
    e.stopPropagation()
    if (isMenuOpen) closeMenu(false)
    else openMenu(moreBtnRef.current)
  }, [isMenuOpen, openMenu, closeMenu])
  const onContextMenu = _react.useCallback.call(void 0, (e) => {
    if (!hasMenu) return
    e.preventDefault()
    openMenu(moreBtnRef.current)
  }, [hasMenu, openMenu])
  const onKeyDown = _react.useCallback.call(void 0, (e) => {
    if (!hasMenu || !((e.shiftKey && e.key === 'F10') || e.key === 'ContextMenu')) return
    e.preventDefault()
    openMenu(document.activeElement instanceof HTMLElement ? document.activeElement : moreBtnRef.current)
  }, [hasMenu, openMenu])

  const rootClassName = _classBuilder2.default.call(void 0, 
    "inbox-row",
    isCompleted && "is-archived",
    isSelected && "is-selected",
    isUnread && "is-unread",
    hasMetaLine && "has-meta",
    // Hover and focus swap the time for the buttons only when there are some.
    (shouldShowActionBtn || hasMenu) && "has-action",
    isMenuOpen && "is-menu-open",
  )

  // The … button and Archive (or Unarchive) float over line 1 on hover, so the
  // name keeps its full width.
  const rowActions = (shouldShowActionBtn || hasMenu) && (
    _react2.default.createElement('div', {
      className: _classBuilder2.default.call(void 0, 
        'inbox-row--actions',
        'inbox-row--actions--overlay',
        isCompleted && shouldShowActionBtn && 'inbox-row--actions--unarchive',
        isBeingArchived && 'inbox-row--actions--busy',
        hasMenu && 'inbox-row--actions--has-menu',
        isMenuOpen && 'inbox-row--actions--open',
      ),
      onClick: stopPropagation, __self: this, __source: {fileName: _jsxFileName, lineNumber: 221}}

      ,  isBeingArchived
        ? _react2.default.createElement(_Spinner.SimpleSpinner, { className: "inbox-row--actions--loader", __self: this, __source: {fileName: _jsxFileName, lineNumber: 233}} )
        : _react2.default.createElement(_react2.default.Fragment, null
            ,  hasMenu && (
              _react2.default.createElement('button', {
                ref: moreBtnRef,
                type: "button",
                'aria-label': "Chat actions" ,
                'aria-haspopup': "menu",
                'aria-expanded': isMenuOpen,
                onClick: onMoreClick,
                className: "inbox-row--action inbox-row--action--more" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 236}}

                , _react2.default.createElement(_icons.MoreIcon, { size: 20, __self: this, __source: {fileName: _jsxFileName, lineNumber: 245}} )
              )
            )
            ,  canToggleArchived && (
              _react2.default.createElement(_ActionBtn2.default, {
                isCompleted: isCompleted,
                onToggle: handleToggleArchived,
                label: actionLabel, __self: this, __source: {fileName: _jsxFileName, lineNumber: 249}}
              )
            )
          )
      
    )
  )

  const content = (
    _react2.default.createElement('div', {
      className: rootClassName,
      onClick: onInboxItemClick,
      onContextMenu: onContextMenu,
      onKeyDown: onKeyDown,
      'aria-current': isSelected || undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 261}}

      , _react2.default.createElement(_InboxItemAvatar2.default, { bkey: blobjectKey, size: AVATAR_SIZE, __self: this, __source: {fileName: _jsxFileName, lineNumber: 268}} )
      , _react2.default.createElement('div', { className: "inbox-row--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 269}}
        , _react2.default.createElement('div', { className: "inbox-row--line", __self: this, __source: {fileName: _jsxFileName, lineNumber: 270}}
          , _react2.default.createElement('span', { className: "inbox-row--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 271}},  name )
          , _react2.default.createElement('span', { className: "inbox-row--time", __self: this, __source: {fileName: _jsxFileName, lineNumber: 272}}
            ,  _time.getTimeString.call(void 0, lastUpdated) 
          )
        )
        , _react2.default.createElement('div', { className: "inbox-row--line", __self: this, __source: {fileName: _jsxFileName, lineNumber: 276}}
          , _react2.default.createElement('span', { className: "inbox-row--preview", __self: this, __source: {fileName: _jsxFileName, lineNumber: 277}}
            ,  !isUnread && draftMessage
              ? _react2.default.createElement(_react2.default.Fragment, null
                  , _react2.default.createElement('span', { className: "inbox-row--draft", __self: this, __source: {fileName: _jsxFileName, lineNumber: 280}}, "Draft:"), ' '
                  ,  draftMessage 
                )
              : description
            
          )
          ,  isMuted && (
            _react2.default.createElement('span', { className: "inbox-row--muted", role: "img", 'aria-label': "Muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 287}}
              , _react2.default.createElement(_icons.MutedIcon, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 288}} )
            )
          )
          /* One place for the pin (D-19): the end of the preview line, just
              before an unread dot or count. */
          ,  isPinned && (
            _react2.default.createElement('span', { className: "inbox-row--pin", role: "img", 'aria-label': "Pinned", __self: this, __source: {fileName: _jsxFileName, lineNumber: 294}}
              , _react2.default.createElement(_icons.PinnedIcon, { size: 16, __self: this, __source: {fileName: _jsxFileName, lineNumber: 295}} )
            )
          )
          ,  unreadMentions
            ? _react2.default.createElement('span', { className: "inbox-row--mentions", title: "Unread mentions" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 299}},  unreadMentions )
            : isUnread && _react2.default.createElement('span', { className: "inbox-row--unread-dot", role: "img", 'aria-label': "Unread", __self: this, __source: {fileName: _jsxFileName, lineNumber: 300}} ) 
        )
        ,  hasMetaLine && (
          _react2.default.createElement('div', { className: "inbox-row--line inbox-row--meta" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 303}}
            ,  hasUnsentScheduled && (
              _react2.default.createElement('span', { role: "img", 'aria-label': _scheduledMessages3.UNSENT_SCHEDULED_PILL_LABEL, className: "list-item--not-sent", __self: this, __source: {fileName: _jsxFileName, lineNumber: 305}}
                ,  _scheduledMessages3.UNSENT_SCHEDULED_PILL_TEXT 
              )
            )
            ,  isInsecure && _react2.default.createElement(_InsecureTextTag.InsecureTextPill, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 309}} ) 
            ,  requestKeywords.map(keyword => _react2.default.createElement(_KeywordChip2.default, { key: keyword, keyword: keyword, __self: this, __source: {fileName: _jsxFileName, lineNumber: 310}} )) 
            ,  teamNames && (
              _react2.default.createElement('span', { className: "inbox-row--teams", __self: this, __source: {fileName: _jsxFileName, lineNumber: 312}}
                , _react2.default.createElement(_icons.TeamIcon, { size: 12, __self: this, __source: {fileName: _jsxFileName, lineNumber: 313}} )
                , _react2.default.createElement('span', { className: "inbox-row--teams-names", __self: this, __source: {fileName: _jsxFileName, lineNumber: 314}},  teamNames )
              )
            )
          )
        )
      )
      ,  rowActions 
      ,  isMenuOpen && hasMenu && _react2.default.createElement(_RowMenu2.default, { anchorRef: moreBtnRef, items: menuItems, onClose: closeMenu, __self: this, __source: {fileName: _jsxFileName, lineNumber: 321}} ) 
    )
  )

  return hasTooltip
    ? _react2.default.createElement(_FirstTimeTooltips.WithFirstChatTooltip, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 326}},  content )
    : content
}

exports. default = _react.memo.call(void 0, InboxListItem)
